import { SERVICES } from 'src/config/constants'
import { Loader } from 'src/utils/loader'

class ResLoader extends Loader {}

export const resLoader = new ResLoader({
  service: SERVICES.res
})
